<template>
  <div class="p-select-container">
    <label :id="`p-select-label-${id}`" class="sr-only">Select answers</label>
    <VueSelect
      v-model="selected"
      :options="options"
      :multiple="multiple"
      :placeholder="placeholder"
      :label="label"
      class="form-control"
      :aria-labelledby="`p-select-label-${id}`"
      :aria-multiselectable="multiple ? 'true' : 'false'"
    />
    <a
      v-if="addAll"
      href="#"
      class="add-all-link text-amethyst fs-sm mt-2"
      @click.prevent="selectAllOptions"
      @keydown.enter.prevent="selectAllOptions"
      @keydown.space.prevent="selectAllOptions"
      aria-label="Add all options to selection"
      tabindex="0"
    >
      <i class="fa fa-fw fa-plus" aria-hidden="true"></i>Add All Options
    </a>
  </div>
</template>

<script setup>
  /** Publinker Select Component **/
  import { ref, watch } from 'vue'
  import VueSelect from 'vue-select'
  import 'vue-select/dist/vue-select.css'

  // Define as props que o componente recebe
  const props = defineProps({
    id: {
      type: String,
      default: () => `p-select-${Math.random().toString(36).substr(2, 9)}` // ID único por padrão
    },
    modelValue: {
      type: Array,
      default: () => []
    },
    options: {
      type: Array,
      required: true
    },
    multiple: {
      type: Boolean,
      default: true
    },
    addAll: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: 'Select options'
    },
    label: {
      type: String,
      default: 'text'
    }
  })

  // Define eventos emitidos para os pais
  const emit = defineEmits(['update:modelValue'])

  // Cria o estado interno para gerenciar os valores selecionados
  const selected = ref([...props.modelValue])

  // Sincroniza o estado interno com o modelValue recebido
  watch(
    () => selected.value,
    newVal => {
      emit('update:modelValue', newVal) // Atualiza o valor para o pai
    },
    { deep: true }
  )

  // Método para selecionar todas as opções
  const selectAllOptions = () => {
    selected.value = [...props.options]
  }
</script>

<style scoped>
  .p-select-container {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }
  .add-all-link {
    font-size: 0.9rem;
    text-decoration: underline;
    cursor: pointer;
    width: auto !important;
  }
  .add-all-link:hover {
    text-decoration: none;
  }
</style>
